import React, { useMemo, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import useLatestQuotesWithPolicies from '../../../../../hooks/useLatestQuotesWithPolicies';
import useCustomerStore from '../../../../../stores/customerStore';
import useProductStore from '../../../../../stores/productStore';
import useWidgetStore, { CurrentTabEnum, } from '../../../../../stores/widgetStore';
import DeclinePopup from './DeclinePopup';
var returnShortId = function (id) {
    var parts = id.split('-');
    return parts[0] + '-' + parts[1].slice(0, 4);
};
var StatusDisplay = function (_a) {
    var _b, _c;
    var handleClick = _a.handleClick, externalAppId = _a.externalAppId, coverageType = _a.coverageType, disabled = _a.disabled;
    var latestQuotesWithPolicies = useLatestQuotesWithPolicies();
    var applicationFormData = useCustomerStore().applicationFormData;
    var setProduct = useProductStore().setProduct;
    var _d = useState(false), declined = _d[0], setDeclined = _d[1];
    var _e = useState(false), declinedPopup = _e[0], setDeclinedPopup = _e[1];
    var _f = useWidgetStore(), setSelectedQuote = _f.setSelectedQuote, setAnswers = _f.setAnswers, setApplicationDataId = _f.setApplicationDataId, setFormActive = _f.setFormActive, setCurrentTab = _f.setCurrentTab, setModalOpen = _f.setModalOpen, setSelectedPolicy = _f.setSelectedPolicy;
    var currentItem = latestQuotesWithPolicies.find(function (_a) {
        var externalId = _a.externalId;
        return externalId === externalAppId;
    });
    var isBrizaUnifiedHiscox = (currentItem === null || currentItem === void 0 ? void 0 : currentItem.partnerIdentifier) === 'brizaUnifiedHiscox';
    // Todo: Important! - This need to be dynamic, not "hiscox-"
    var mapCoverageTypeToPartnerKey = {
        GL: 'hiscox-gl',
        BOP: 'hiscox-bop',
        Cyber: 'hiscox-cyber',
        PL: 'hiscox-eo'
    };
    var _g = useMemo(function () {
        var _a, _b;
        var identifier;
        var currentStatus;
        var DisplayId;
        if (!currentItem) {
            identifier = 'Application';
            currentStatus = 'start';
        }
        else {
            if (!!currentItem.policy) {
                identifier = 'Policy';
                currentStatus = currentItem.policy.insuranceStatus;
                DisplayId = String(returnShortId(currentItem.policy.id));
            }
            else {
                identifier = 'Quote';
                currentStatus =
                    ((_b = (_a = currentItem.partnerData) === null || _a === void 0 ? void 0 : _a.quotes[mapCoverageTypeToPartnerKey[coverageType]]) === null || _b === void 0 ? void 0 : _b.status) || currentItem.status;
                DisplayId = String(returnShortId(currentItem.id));
            }
        }
        return { identifier: identifier, currentStatus: currentStatus, DisplayId: DisplayId };
    }, [currentItem]), identifier = _g.identifier, currentStatus = _g.currentStatus, DisplayId = _g.DisplayId;
    var selectPolicyHandler = function (quote) {
        var _a;
        setSelectedQuote(quote.id);
        setModalOpen(true);
        var answers = (_a = applicationFormData === null || applicationFormData === void 0 ? void 0 : applicationFormData[quote.externalId]) === null || _a === void 0 ? void 0 : _a.applicationDetails;
        setProduct(quote.product);
        setAnswers(answers);
        setApplicationDataId(quote.externalId);
        setFormActive(true);
        if (quote.status === 'bound' || quote.status === 'MT Draft') {
            setSelectedPolicy({
                policyId: quote.policy.id,
                externalId: quote === null || quote === void 0 ? void 0 : quote.externalId
            });
            setCurrentTab(CurrentTabEnum.POLICY_INFO);
        }
        setCurrentTab(CurrentTabEnum.POLICY);
    };
    var onClickHandler = function () {
        if (identifier === 'Application') {
            handleClick();
        }
        else {
            selectPolicyHandler(currentItem);
        }
    };
    var statusMapper = {
        start: {
            checkIcon: true,
            buttonText: 'Accept Quote',
            declineButtonText: 'Decline no-obligation Quote'
        },
        queued: {
            buttonText: 'Pending'
        },
        pending: {
            buttonText: 'Pending'
        },
        referred: {
            buttonText: 'Referred'
        },
        complete: {
            buttonText: 'Purchase Now',
            declineButtonText: 'Decline Protection',
            checkIcon: true,
            declinePopupTitle: {
                GL: 'Decline General Liability Protection',
                BOP: 'Decline Decline Business Owners Policy Protection',
                Cyber: 'Decline Adaptive Cyber Protection',
                PL: 'Decline Professional Liability Protection'
            },
            declinePopupText: {
                GL: 'I understand the risks associated with being uninsured or underinsured.',
                BOP: 'I understand the risks associated with being uninsured or underinsured.',
                Cyber: 'I understand the risks associated with being uninsured or underinsured, and acknowledge that without Adaptive Cybersecurity coverage my business cannot earn “Benchmark” status as a preferred vendor within the Vibrant platform',
                PL: 'I understand the risks associated with being uninsured or underinsured.'
            }
        },
        quoted: {
            buttonText: 'Purchase Now',
            declineButtonText: 'Decline Protection',
            checkIcon: true,
            declinePopupTitle: {
                GL: 'Decline General Liability Protection',
                BOP: 'Decline Decline Business Owners Policy Protection',
                Cyber: 'Decline Adaptive Cyber Protection',
                PL: 'Decline Professional Liability Protection'
            },
            declinePopupText: {
                GL: 'I understand the risks associated with being uninsured or underinsured.',
                BOP: 'I understand the risks associated with being uninsured or underinsured.',
                Cyber: 'I understand the risks associated with being uninsured or underinsured, and acknowledge that without Adaptive Cybersecurity coverage my business cannot earn “Benchmark” status as a preferred vendor within the Vibrant platform',
                PL: 'I understand the risks associated with being uninsured or underinsured.'
            }
        },
        active: {
            buttonText: 'Active'
        },
        bound: {
            buttonText: 'Active'
        },
        rejected: {
            buttonText: 'Restart',
            text: 'Declined'
        },
        failed: {
            buttonText: 'Failed',
            text: 'Failed'
        },
        expired: {
            buttonText: 'Renew',
            text: 'Expired'
        },
        draft: {
            buttonText: 'Pending'
        }
    };
    var current = statusMapper[currentStatus];
    console.log('🚀 ~ StatusDisplay ~ currentStatus:', currentStatus);
    var declineHandler = function () {
        setDeclined(true);
        closeDeclinePopup();
    };
    var closeDeclinePopup = function () {
        setDeclinedPopup(false);
    };
    var onDeclineHandler = function () {
        setDeclined(function (prev) {
            var _a, _b;
            if (prev === false) {
                if (((_a = current.declinePopupTitle) === null || _a === void 0 ? void 0 : _a[coverageType]) ||
                    ((_b = current.declinePopupText) === null || _b === void 0 ? void 0 : _b[coverageType])) {
                    setDeclinedPopup(true);
                    return false;
                }
                else {
                    return true;
                }
            }
            return false;
        });
    };
    return (React.createElement(React.Fragment, null,
        declinedPopup && (React.createElement(DeclinePopup, { title: (_b = current.declinePopupTitle) === null || _b === void 0 ? void 0 : _b[coverageType], text: (_c = current.declinePopupText) === null || _c === void 0 ? void 0 : _c[coverageType], onSuccess: declineHandler, onClose: closeDeclinePopup })),
        React.createElement("div", { className: "flex flex-col md:flex-row md:items-center md:justify-between p-4 gap-4" },
            React.createElement("div", { className: "flex flex-col items-start md:items-end" },
                identifier !== 'Application' && (React.createElement("p", { className: "font-semibold text-gray-900 text-left md:text-right" },
                    React.createElement("span", { className: "font-normal text-gray-600 mr-1" }, isBrizaUnifiedHiscox
                        ? 'Application ID:'
                        : "".concat(identifier, " Number:")),
                    DisplayId)),
                (current === null || current === void 0 ? void 0 : current.text) && (React.createElement("p", { className: "flex items-center text-sm font-semibold text-left md:text-right" },
                    React.createElement("span", { className: "h-2 w-2 bg-[#FD515E] rounded-full mr-2" }),
                    current.text))),
            React.createElement("div", { className: "flex flex-col gap-[6px] md:items-end" },
                React.createElement("button", { onClick: onClickHandler, disabled: declined || disabled, title: isBrizaUnifiedHiscox ? 'View Application' : current === null || current === void 0 ? void 0 : current.buttonText, className: "h-[40px] px-4 w-full md:w-auto md:min-w-[144px] flex items-center justify-center text-white rounded-lg cursor-pointer gap-2 text-sm\n                  bg-[#11BDB0]\n                  disabled:opacity-50 disabled:cursor-not-allowed" },
                    !isBrizaUnifiedHiscox && (current === null || current === void 0 ? void 0 : current.checkIcon) && (React.createElement(FontAwesomeIcon, { icon: faCheck })),
                    ' ',
                    React.createElement("span", { className: "truncate md:max-w-[100px] block text-ellipsis overflow-hidden whitespace-nowrap" }, isBrizaUnifiedHiscox ? 'View Application' : current.buttonText)),
                current.declineButtonText && !isBrizaUnifiedHiscox && (React.createElement("button", { onClick: onDeclineHandler, disabled: disabled, title: current === null || current === void 0 ? void 0 : current.declineButtonText, className: "h-[40px] px-4 w-full md:w-auto md:min-w-[144px] flex items-center justify-center rounded-lg gap-2 text-sm ".concat(declined
                        ? 'bg-[#f00] text-white'
                        : 'border text-[#707EAE] border-[#707EAE] disabled:opacity-50') },
                    React.createElement(FontAwesomeIcon, { icon: faXmark }),
                    React.createElement("span", { className: "truncate  md:max-w-[100px] block text-ellipsis overflow-hidden whitespace-nowrap" }, current.declineButtonText)))))));
};
export default StatusDisplay;
